module.exports = __webpack_public_path__ + "media/onboarding/woman-d23aa224.svg";